<template>
    <div class="main main-padding">
        <div class="top-area">
            <!--时间选择器-->
            <div class="time-select-picker">
                <div class="time-select">
                    <Row :gutter="10">
                        <date-select @updateDateTime="updateDateTime" ref="dateSelect"></date-select>
                    </Row>
                </div>
            </div>
        </div>
        <!--大屏使用版本，活跃教师用户，教师使用场景-->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="12" :sm="12" :md="12" :lg="8" :xl="6" class="top-tea-screen-dis">
                <pie-charts
                    :chartsTitle="'大屏使用版本'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'yq_school_screen_version'"
                    :pieChartsName="'版本分布'"
                    ref="schoolScreenVersion"
                ></pie-charts>
            </Col>
            <Col :xs="12" :sm="12" :md="12" :lg="8" :xl="6" class="top-tea-screen-dis">
                <histogram-charts
                    :chartsTitle="'活跃教师用户Top10 (可点击柱状图)'"
                    :isShowMore=true
                    :isClickCharts=true
                    :chartsId="'yq_school_active_top'"
                    :height="'360px'"
                    :histogramTooltip="'useSecond'"
                    ref="schoolActiveTop"
                    @click-more-data="clickMoreData"
                    @look-more-data="lookMoreData"
                ></histogram-charts>
            </Col>
            <Col :xs="12" :sm="12" :md="12" :lg="8" :xl="6" class="top-tea-screen-dis">
                <pie-charts
                    :chartsTitle="'大屏使用场景整体分布(可点击饼图)'"
                    :isShowMore=true
                    :isClickCharts=true
                    :chartsId="'yq_school_screen_scene_distri'"
                    :pieChartsName="'场景分布'"
                    ref="yqScreenDistribution"
                    @click-more-data="clickMoreData"
                    @look-more-data="lookMoreData"
                ></pie-charts>
            </Col>
        </Row>
        <!-- 大屏日活用户趋势图-->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <line-charts
                    :chartsTitle="'大屏使用趋势图'"
                    :chartsId="'yq_school _screen_trend'"
                    :lineCompany="'块'"
                    ref="schoolScreenTrend"
                ></line-charts>
            </Col>
        </Row>
    </div>
</template>
<script>

    import dateSelect from "../../components/dateSelect.vue";//时间选择器
    import HistogramCharts from "../../components/charts/HistogramCharts.vue";//柱状图
    import PieCharts from "../../components/charts/PieCharts.vue";//饼状图
    import LineCharts from "../../components/charts/LineCharts.vue";//折线图
    import {findActiveTeacherTop, getSchoolScreenMap, getScreenVersion, findTeacherScenes} from "../../service/api.js";

    export default {
        name: "wisdom-main",
        data () {
            return {
                schoolId: this.$route.query.schoolId,
                // schoolName: this.$route.query.schoolName,
                phase: this.$route.query.phase,
                startDate: this.$route.query.startDate === undefined ? "" : this.$route.query.startDate,
                endDate: this.$route.query.endDate === undefined ? "" : this.$route.query.endDate,
                activeTeacherList: [],//活跃教师Top10数据集合
            };
        },
        components: {
            dateSelect,//时间选择器
            HistogramCharts,//柱状图组件
            PieCharts,//饼图组件
            LineCharts//折线图
        },
        methods: {
            /**
             * 返回上一页
             */
            gotoBack () {
                this.$router.push({
                    name: "wisdomClassStatic",
                    query: {
                        phase: this.phase
                    }
                });
            },
            /**
             * 点击查看更多数据
             */
            lookMoreData (chartsId, productKey) {
                let routeData = {};
                if (chartsId === 'yq_school_active_top') {
                    //点击查看活跃教师top10的更多数据
                    routeData = this.$router.resolve({
                        name: "activeTeaTopDetails",
                        query: {
                            schoolId: this.schoolId,
                            schoolName: this.schoolName,
                            routerName: "wisdomMain",
                            parentalStartDate: this.startDate,
                            parentalEndDate: this.endDate,
                            type: 2 //戴特教育：1；一起作业：2
                        }
                    });
                } else if (chartsId === 'yq_school_screen_scene_distri') {
                    //点击查看大屏使用场景整体分布的更多数据
                    routeData = this.$router.resolve({
                        name: "screenDistriDetails",
                        query: {
                            schoolId: this.schoolId,
                            routerName: "wisdomMain",
                            schoolName: this.schoolName,
                            startDate: this.startDate,
                            endDate: this.endDate
                        }
                    });
                }
                window.open(routeData.href, "_parent");
            },
            /**
             *点击图表
             */
            clickMoreData (params, chartsId, productKey) {
                if (chartsId === 'yq_school_active_top') {
                    //点击查看活跃教师top10的更多数据
                    this.$router.push({
                        name: "activeTeaDetails",
                        query: {
                            schoolId: this.schoolId,
                            schoolName: this.schoolName,
                            routerName: "wisdomMain",
                            selfStartDate: this.startDate,
                            selfEndDate: this.endDate,
                            userId: this.activeTeacherList[params.dataIndex].userId,
                            tabsName: "",
                            isShowRemind: "",
                            teaName: 'notAddTime',
                            sourceType: 1
                        }
                    });
                } else if (chartsId === 'yq_school_screen_scene_distri') {
                    //点击查看大屏使用场景整体分布的更多数据
                    this.$router.push({
                        name: "teaUserScreenDetails",
                        query: {
                            schoolId: this.schoolId,
                            schoolName: this.schoolName,
                            routerName: "wisdomMain",
                            startDate: this.startDate,
                            endDate: this.endDate,
                            codingKey: params.data.codingKey  //场景编码
                        }
                    });
                }
            },
            /**
             * 更新开始时间结束时间
             */
            updateDateTime (startDate, endDate) {
                this.startDate = startDate;
                this.endDate = endDate;
                //获取大屏使用版本
                this.getScreenVersion();
                //大屏使用场景整体分布
                this.getTeacherScenes();
                // 获取活跃教师用户Top10数据
                this.getActiveTeacherTop();
                // 获取大屏使用趋势图
                this.getSchoolScreenMap();
            },
            /**
             * 获取大屏使用版本
             */
            async getScreenVersion () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.startDate,
                    endDate: _this.endDate,
                    type: 2 //戴特教育：1；一起作业：2
                };
                await getScreenVersion(params)
                    .then(function (data) {
                        let versionList = data;
                        let nameArr = [];
                        let dataArr = [];
                        for (let i = 0; i < versionList.length; i++) {
                            let obj = {};
                            //处理数据用于渲染图表
                            obj.value = versionList[i].count;
                            obj.name = versionList[i].product_version;
                            dataArr.push(obj);
                            nameArr.push(versionList[i].product_version);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.schoolScreenVersion.initDataSource(versionList, nameArr, dataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },

            /**
             * 获取活跃教师用户Top10数据
             */
            async getActiveTeacherTop () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.startDate,
                    endDate: _this.endDate,
                    type: 2 //戴特教育：1；一起作业：2
                };
                await findActiveTeacherTop(params)
                    .then(function (data) {
                        _this.activeTeacherList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        //处理数据以渲染图表
                        for (let i = 0; i < _this.activeTeacherList.length; i++) {
                            xDataArr.push(_this.activeTeacherList[i].fullName);
                            seriesDataArr.push(_this.activeTeacherList[i].count);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.schoolActiveTop.initDataSource(_this.activeTeacherList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取大屏使用场景整体分布
             */
            async getTeacherScenes () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.startDate,
                    endDate: _this.endDate,
                    type: 2 //戴特教育：1；一起作业：2
                };
                await findTeacherScenes(params)
                    .then(function (data) {
                        let sceneUseList = data;
                        let nameArr = [];
                        let dataArr = [];
                        for (let i = 0; i < sceneUseList.length; i++) {
                            let obj = {};
                            obj.value = sceneUseList[i].userCount;
                            obj.name = sceneUseList[i].clsName;
                            obj.codingKey = sceneUseList[i].coding_key;
                            dataArr.push(obj);
                            nameArr.push(sceneUseList[i].clsName);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.yqScreenDistribution.initDataSource(sceneUseList, nameArr, dataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取大屏使用趋势图
             */
            async getSchoolScreenMap () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    type: 3,
                    state: 2  //戴特教育：1；一起作业：2
                };
                await getSchoolScreenMap(params)
                    .then(function (data) {
                        let curResultData = data;
                        let dateArr = [];
                        let numberArr = [];
                        for (let i = 0; i < curResultData.length; i++) {
                            dateArr.push(curResultData[i].date);
                            numberArr.push(curResultData[i].number);
                        }
                        //渲染图表
                        _this.$refs.schoolScreenTrend.initDataSource(curResultData, dateArr, numberArr);
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            }
        },
        mounted () {
            this.$nextTick(() => {
                //修改公共属性学校名称
                // this.$store.commit("SET_TOPHEADERNAME", this.schoolName);
                this.$store.commit("SET_TOPHEADERNAME", "一起智慧课堂");
                //当月开始日期
                this.startDate = this.startDate === "" ? this.$utils.getMonthStartDate() : this.startDate;
                //当月结束日期
                this.endDate = this.endDate === "" ? this.$utils.getMonthEndDate() : this.endDate;
                //初始化时间组件开始、结束日期,获取默认时间
                this.$refs.dateSelect.setDate(this.startDate, this.endDate);
                //大屏使用场景整体分布
                this.getTeacherScenes();
                //获取大屏使用版本
                this.getScreenVersion();
                // 获取大屏使用趋势图
                this.getSchoolScreenMap();
                // 获取活跃教师用户Top10数据
                this.getActiveTeacherTop();

            });
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../style/home";
</style>
<style lang="scss">
    .school-mian-cards.ivu-col-span-xl-4 {
        width: 20%;
    }

    .top-tea-screen-dis.ivu-col-span-xl-6 {
        width: 33.33%;
    }

    .table-list-right-btn {
        position: absolute;
        top: 28px;
        right: 23px;
    }

    .demo-spin-container {
        display: inline-block;
        width: 100%;
        height: 100%;
        position: relative;
        border: 1px solid #eee;
    }

    .data_select.time-slot .ivu-col-span-lg-4 {
        display: block;
        width: 23%;
    }

    .time-select {
        .ivu-row {
            margin-top: 0 !important;
        }
    }

    .main-padding {
        .ivu-input-group {
            width: 300px;
            float: right;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }


        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }

        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>
